<template>
  <v-app id="representacion-rechazar">
    <v-btn color="primary" :loading="loading" class="ma-2" style="position: absolute; top: 10px; right: 10px;"
      @click="$router.push({ name: 'GastosRepresentacionDetalle', params: { idsolicitud: idsolicitud } })">
      Ir a Detalle Solicitud
    </v-btn>
    <v-container fluid fill-height>
      <v-layout align-center justify-center row>
        <div class="text-md-center">
          <h2 class="my-3 headline" v-if="mensaje">{{ mensaje }}</h2>
          <h3 class="subtitle-1" v-if="estatus">Estatus: {{ estatus }}</h3>
        </div>
      </v-layout>
    </v-container>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import services from "@/config/services";
import axios from "axios";

export default {
  name: "RepresentacionRechazar",
  data() {
    return {
      idsolicitud: null,
      loading: false,
      mensaje: null,
      estatus: null,
    };
  },
  async mounted() {
    await this.rechazarSolicitud();
  },
  methods: {
    async rechazarSolicitud() {
      this.loading = true
      const id = this.$route.params.idsolicitud;
      this.idsolicitud = id
      const jwt = this.$session.get("jwt");
      const headers = { Authorization: "Bearer " + jwt };
      const url = services.routes.representacionSolicitudesRechazar.replace(
        ":idsolicitud",
        id
      );
      try {
        const response = await axios.post(url, {}, { headers });
        this.mensaje = response.data.mensaje;
        this.estatus = response.data.estatus;
      } catch (err) {
        this.estatus = null;
        if (err && err.response && err.response.data) {
          this.mensaje = err.response.data.message || 'Error del servidor';
        } else {
          this.mensaje = err.message || 'Error desconocido';
        }
        console.error(err);
      } finally {
        this.loading = false
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 80px;
  line-height: 90px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
